import { paths } from "@rms-types/constants/paths";
import { lazy } from "react";

import { AppRoute } from "@/routes/types";

export const queueRoutes: AppRoute[] = [
  {
    index: true,
    page: lazy(() => import("@/pages/queue").then((module) => ({ default: module.Queue }))),
    permissions: paths.app.queue.permissions,
  },
  {
    path: paths.app.queue.details.path,
    page: lazy(() => import("@/layouts/content-layout").then((module) => ({ default: module.ContentLayout }))),
    permissions: paths.app.queue.details.permissions,
    children: [
      {
        index: true,
        page: lazy(() => import("@/pages/queue/queueId").then((module) => ({ default: module.QueueDetails }))),
      },
      {
        path: paths.app.queue.details.applicationDetails.path,
        page: lazy(() =>
          import("@/pages/queue/queueId/application/applicationId").then((module) => ({
            default: module.Application,
          }))
        ),
        permissions: paths.app.queue.details.applicationDetails.permissions,
      },
      {
        path: paths.app.queue.details.disclosureDetails.path,
        page: lazy(() =>
          import("@/pages/queue/queueId/disclosure").then((module) => ({
            default: module.default,
          }))
        ),
        children: [
          {
            path: paths.app.queue.details.disclosureDetails.profile.path,
            page: lazy(() =>
              import("@/pages/queue/queueId/disclosure/disclosureId/disclosure-profile").then((module) => ({
                default: module.DisclosureProfile,
              }))
            ),
          },
          {
            path: paths.app.queue.details.disclosureDetails.additionalSharedFiles.path,
            page: lazy(() =>
              import("@/pages/queue/queueId/disclosure/disclosureId/additional-shared-files").then((module) => ({
                default: module.DisclosureAdditionalSharedFiles,
              }))
            ),
          },
          {
            path: paths.app.queue.details.disclosureDetails.section.path,
            page: lazy(() =>
              import("@/pages/queue/queueId/disclosure/disclosureId/section/sectionId").then((module) => ({
                default: module.DisclosureSection,
              }))
            ),
          },
        ],
      },
    ],
  },
];
